
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/update-profile",
      function () {
        return require("private-next-pages/update-profile.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/update-profile"])
      });
    }
  